import { render, staticRenderFns } from "./ProductDeliver.vue?vue&type=template&id=2ba6278e&scoped=true&"
import script from "./ProductDeliver.vue?vue&type=script&lang=js&"
export * from "./ProductDeliver.vue?vue&type=script&lang=js&"
import style0 from "./ProductDeliver.vue?vue&type=style&index=0&id=2ba6278e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6278e",
  null
  
)

export default component.exports